import Accordion from './Accordion.vue';
export default Accordion;
